import React from "react";
import { Button } from "~/components/ui/button";
import { LogoLong } from "~/icons/Logo";

const Dashboard = () => {
  const params = new URLSearchParams(window.location.search);
  const redirectTo = params.get("redirect_to") ?? "/";
  const error = params.get("error");

  const googleAuthUrl = `/google/sign_in/start?redirect_to=${encodeURIComponent(redirectTo)}`;
  const bypassUrl = `/login?redirect_to=${encodeURIComponent(redirectTo)}&bypass=true`;

  return (
    <div className="h-screen min-h-[600px] w-full lg:grid lg:grid-cols-2 xl:min-h-[800px]">
      <div className="hidden bg-muted lg:block">
        <div className="h-full w-full bg-secondary object-cover dark:brightness-[0.2] dark:grayscale" />

        <div className="absolute left-8 top-8 flex flex-row items-center gap-[6.5px]">
          <LogoLong variant="black" className="h-[30px] w-auto" />
        </div>
      </div>

      <div className="flex h-full items-center justify-center py-12">
        <div className="absolute left-8 top-8 flex flex-row items-center gap-[6.5px] lg:hidden">
          <LogoLong variant="black" className="h-[30px] w-auto" />
        </div>

        <div className="mx-auto grid w-[350px] gap-6">
          <div className="grid gap-2 text-center">
            <h1 className="text-3xl font-bold">Login</h1>
            <p className="text-balance text-muted-foreground">
              Click the button below to login with Google
            </p>
          </div>

          {error !== null && (
            <div className="rounded-md bg-destructive/15 p-3 text-sm text-destructive">{error}</div>
          )}

          <div className="grid gap-4">
            <Button className="w-full" asChild>
              <a href={googleAuthUrl}>Login with Google</a>
            </Button>

            {process.env.NODE_ENV !== "production" && (
              <Button variant="destructive" className="w-full" asChild>
                <a href={bypassUrl}>[DEV] login</a>
              </Button>
            )}
          </div>

          <p className="text-center text-sm text-muted-foreground">
            By logging into our dashboard, you also agree to our{" "}
            <a
              href="https://pocketflows.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-foreground"
            >
              terms of service
            </a>{" "}
            and{" "}
            <a
              href="https://pocketflows.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-foreground"
            >
              privacy policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export const LoginApp = () => {
  return <Dashboard />;
};
